import React, { Fragment } from 'react';

// material-ui
import {
  Box,
  Chip,
  Divider,
  ListItemAvatar,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography
} from '@mui/material';

import AssetLogo from '../AssetLogo';
import { MerchantCashAdvance } from '../../graphql/types';
import { CurrencyText } from '../../components/input-formatters/CurrencyText';

export interface McaListOptionProps {
  mca: MerchantCashAdvance;
  onClick?: any;
}

function McaListButtonOption(props: McaListOptionProps) {
  const mca = props.mca;
  return (
    <Fragment>
      <ListItemButton {...props}>
        <ListItemAvatar sx={{ minWidth: 42 }}>
          <Box sx={{ width: 24, height: 24, mr: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <AssetLogo logo={mca?.merchant?.logo} name={mca?.merchant?.legalName} size="sm" />
          </Box>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Stack component="span" direction="column" alignItems="left" justifyContent="space-between" spacing={0.2}>
              <Typography component="span" color="inherit" variant="caption">
                {`MCA #${mca.number}`}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {mca?.merchant?.legalName}
              </Typography>
            </Stack>
          }
        />
        <ListItemSecondaryAction>
          <Stack mb={3}>
            <Chip color={'error'} label={<CurrencyText value={mca.balanceclr || 0} />} size="small" variant="light" />
          </Stack>
        </ListItemSecondaryAction>
      </ListItemButton>
      <Divider />
    </Fragment>
  );
}

export default McaListButtonOption;
